import { Card } from 'react-bootstrap';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styled from 'styled-components';
import { LIBRARY_TYPES } from '../../../../ciatEU/hook';
import softKey from '../../../../assets/img/softKey.jpeg';
import hardKey from '../../../../assets/img/hardKey.jpeg';

const MEDIA_TYPES = {
  [LIBRARY_TYPES.file]: { animation: softKey, caption: 'Файловий ключ.' },
  [LIBRARY_TYPES.km]: { animation: hardKey, caption: 'Апаратний ключ.' },
};

const StyledCard = styled(Card)`
    & .card-header {
        transition: all 0.4s ease;
    }
    &:hover .card-header{
        background-color: var(--success);
    }
`;
function MediaType({
  type, selected, onSelect, isWideMode,
}) {
  return (
    <StyledCard
      className={classNames(isWideMode ? 'w-50' : 'w-25', { 'shadow-lg': selected })}
      role="button"
      onClick={onSelect}
    >
      {/* {!size && ( */}
      {/* <Card.Body> */}
      {/*  <Lottie animationData={MEDIA_TYPES[type].animation} /> */}
      {/* </Card.Body> */}
      {/* )} */}
      <Card.Img
          // className="d-block mx-auto mb-4"
        src={MEDIA_TYPES[type].animation}
        alt="shield"
        width={100}
      />
      <Card.Header className={classNames({ 'bg-info': selected })}>
        <Card.Title className="text-center fs--1">{MEDIA_TYPES[type].caption}</Card.Title>
      </Card.Header>
    </StyledCard>

  );
}

MediaType.propTypes = {
  type: PropTypes.oneOf(Object.keys(MEDIA_TYPES)),
  selected: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  isWideMode: PropTypes.bool,
};

MediaType.defaultProps = {
  type: null,
  selected: false,
  isWideMode: false,
};

export default MediaType;
